import { Heading } from "@digdir/designsystemet-react";
import type { ReactNode } from "react";
import { cn } from "@/utils";

export const AvtaleSectionWithHeader = ({
  title,
  children,
  className,
}: {
  title: string;
  children: ReactNode[] | ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <SectionHeader value={title} />
      {children}
    </div>
  );
};

const SectionHeader = ({ value }: { value: string }) => {
  return (
    <Heading className="my-2" data-size="xs" level={2}>
      {value}
    </Heading>
  );
};
